import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import Actions from 'actions/Actions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import MobileConfirmModalEN from 'components/GlobalModals/MobileConfirmModal/locales/MobileConfirmModal_en_US';
import MobileConfirmModalFR from 'components/GlobalModals/MobileConfirmModal/locales/MobileConfirmModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const { redirectToHome } = Actions;
const getText = getLocalisedDataFromResource(MobileConfirmModalEN, MobileConfirmModalFR);

const withMobileConfirmModalProps = wrapHOC(
    connect(
        createStructuredSelector({
            mobileModalTitle: getTextFromResource(getText, 'mobileModalTitle'),
            mobileModalSubtitle: getTextFromResource(getText, 'mobileModalSubtitle'),
            sent: getTextFromResource(getText, 'sent'),
            reply: getTextFromResource(getText, 'reply'),
            buttonContinue: getTextFromResource(getText, 'buttonContinue'),
            mobileTerms: getTextFromResource(getText, 'mobileTerms', [
                '/beauty/sms-terms-and-conditions',
                '/beauty/privacy-policy',
                '/beauty/privacy-policy#USNoticeIncentive'
            ]),
            mobileTermsAdditionalInfo: getTextFromResource(getText, 'mobileTermsAdditionalInfo', [])
        }),
        { redirectToHome }
    )
);

export { withMobileConfirmModalProps };
